import React from "react";

interface CustomerCareCallsData {
  benchmark: string; under7Completed: string; totalCallsCompleted: string;
  percentCompletedUnder7: string; percentVsBenchmark: string;
  bonusPercentEarned: string; bonusValue: string; score: string;
}
interface CustomerCareCallsSubFormProps {
  data: CustomerCareCallsData; isEditable: boolean; percentOfTotalAchievementScore: number;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>, options?: { type?: 'number' | 'decimal' | 'text'; maxLength?: number; minLength?: number; max?: number; min?: number }) => void;
}

const CustomerCareCallsSubForm: React.FC<CustomerCareCallsSubFormProps> = ({ data, isEditable, percentOfTotalAchievementScore, onInputChange }) => (
  <div className="sf-section">
    <h3 className="sf-title">Customer Care Calls ({percentOfTotalAchievementScore}% of total achievement score)</h3>
    <p className="sf-subtitle">This will be evaluated from calls completed within 7 days. The goal is 70% of all calls completed within 7 days.</p>
    <div className="grid grid-cols-2 gap-6">
      <div className="space-y-2">
        <label className="sf-label">This quarter the benchmark was:</label>
        <input type="text" readOnly name="customerExperience.customerCareCalls.benchmark"
          value={data.benchmark?.replace('%', '') || "0.70"}
          className="sf-input-ro mt-1 block w-full px-3 py-2" />
      </div>
      <div className="space-y-4">
        <div>
          <label className="sf-label">Under 7 Completed</label>
          <input type="text" name="customerExperience.customerCareCalls.under7Completed"
            inputMode="numeric" maxLength={3} minLength={1}
            value={data.under7Completed} placeholder="0" onFocus={e => e.target.select()}
            disabled={!isEditable} onChange={e => onInputChange(e, { type: "number", maxLength: 3, minLength: 1 })}
            className="sf-input mt-1 block w-full px-3 py-2 text-right" />
        </div>
        <div>
          <label className="sf-label">Total Calls Completed</label>
          <input type="text" name="customerExperience.customerCareCalls.totalCallsCompleted"
            inputMode="numeric" maxLength={3} minLength={1}
            value={data.totalCallsCompleted} placeholder="0" onFocus={e => e.target.select()}
            disabled={!isEditable} onChange={e => onInputChange(e, { type: "number", maxLength: 3, minLength: 1 })}
            className="sf-input mt-1 block w-full px-3 py-2 text-right" />
        </div>
        <div>
          <label className="sf-label">% Completed Under 7</label>
          <input type="text" readOnly name="customerExperience.customerCareCalls.percentCompletedUnder7"
            value={data.percentCompletedUnder7 && !isNaN(parseFloat(data.percentCompletedUnder7)) ? parseFloat(data.percentCompletedUnder7).toFixed(0) : ""}
            className="sf-input-ro mt-1 block w-full px-3 py-2 text-right" />
        </div>
        <div>
          <label className="sf-label">% Under 7 vs Benchmark</label>
          <input type="text" readOnly name="customerExperience.customerCareCalls.percentVsBenchmark"
            value={data.percentVsBenchmark && !isNaN(parseFloat(data.percentVsBenchmark)) ? Math.ceil(parseFloat(data.percentVsBenchmark)).toString() : "0"}
            className="sf-input-ro mt-1 block w-full px-3 py-2 text-right" />
        </div>
      </div>
    </div>
    <p className="sf-hint">70%–120% of Benchmark</p>
    <div className="sf-results grid grid-cols-4 gap-4">
      <div>
        <div className="sf-results-label">Bonus % Earned</div>
        <input type="text" readOnly name="customerExperience.customerCareCalls.bonusPercentEarned"
          value={data.bonusPercentEarned && !isNaN(parseFloat(data.bonusPercentEarned)) ? Math.ceil(parseFloat(data.bonusPercentEarned)).toString() : "0"}
          className="sf-input-ro w-24 px-2 py-1 text-right" />
      </div>
      <div>
        <div className="sf-results-label">{percentOfTotalAchievementScore}%</div>
        <input type="text" readOnly name="customerExperience.customerCareCalls.bonusValue"
          value={data.bonusValue && !isNaN(parseFloat(data.bonusValue)) ? parseFloat(data.bonusValue).toFixed(2) : "0.20"}
          className="sf-input-ro w-24 px-2 py-1 text-right" />
      </div>
      <div>
        <div className="sf-results-label">Score</div>
        <input type="text" readOnly name="customerExperience.customerCareCalls.score"
          value={data.score && !isNaN(parseFloat(data.score)) ? parseFloat(data.score).toFixed(0) : "0"}
          className="sf-input-ro w-24 px-2 py-1 text-right" />
      </div>
    </div>
  </div>
);

export default CustomerCareCallsSubForm;